import * as action from './orderAction'
import { default as actionType } from './orderActionType'
import { default as reducer } from './orderReducer'

export const ORDER = {
  action,
  actionType,
  reducer
}
